import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import * as partnershipActions from "../partnership/partnershipActions";
import * as partnershipSelectors from "../partnership/partnershipSelectors";
import { OrganizationKeyName } from "../../model/Organization";
import { RootState } from "../../store";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { useForm } from "react-hook-form";
import { SelectFormField } from "../common/hook-form/SelectFormField";
import * as _ from "lodash";
import { useCreateUserMembercard } from "../../service/api";
import { UserMemberCardCreatePayload } from "../../service/api-response/UserMemberCardSyncCardSuccessResponse";
import { toastr } from "react-redux-toastr";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { getErrorMessage } from "../../error-handler";

interface Props {
  userId?: string;
  organization: OrganizationKeyName;
  onClose: () => void;
}

export const AddMemberCardPopup: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const formMethods = useForm();
  const { handleSubmit } = formMethods;

  const { mutateAsync: createMembercard, isLoading } = useCreateUserMembercard(
    props.userId?.toString()
  );

  const onSubmit = async (data: any) => {
    if (!props.userId) {
      return;
    }
    const request: UserMemberCardCreatePayload = {
      data,
      organizationKeyName: props.organization,
      userId: props.userId,
    };
    try {
      await createMembercard(request);
      toastr.success("Success", "Member card successfully added to user");
      props.onClose();
    } catch (error: unknown) {
      const errorMessage = getErrorMessage(error);
      toastr.error("Error", errorMessage);
    }
  };

  React.useEffect(
    () => {
      dispatch(partnershipActions.listAction(props.organization));
    },
    // @todo fix
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const partnerships = useSelector((state: RootState) =>
    partnershipSelectors.partnershipList(state, props.organization)
  );

  const partnershipOptions = React.useMemo(
    () =>
      _.chain(partnerships)
        .filter(
          (x) =>
            !x.memberCardTypeName.startsWith("friendcard") &&
            !x.memberCardTypeName.startsWith("familycard") &&
            !x.memberCardTypeName.startsWith("bestfriendcard")
        )
        .map((x) => ({
          label: x.memberCardTypeName,
          value: x.id,
        }))
        .sortBy(["label"])
        .value(),
    [partnerships]
  );

  partnershipOptions.unshift({
    label: "",
    value: "",
  });

  return (
    <Modal isOpen={true}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <ModalHeader>Add member card</ModalHeader>
        <ModalBody>
          <SelectFormField
            name="partnershipId"
            label="Member card type"
            options={partnershipOptions}
            errors={formMethods.formState.errors}
            register={formMethods.register}
            clearErrors={formMethods.clearErrors}
            isRequired={true}
          />
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-default"
            onClick={() => props.onClose()}
          >
            Close
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={isLoading}
          >
            {isLoading ? (
              <FontAwesomeIcon icon={solid("spinner")} pulse spin />
            ) : (
              "Add"
            )}
          </button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default AddMemberCardPopup;
